import { useState, useEffect} from "react";
import {CommonDialogBox} from "components";
import { Box, Typography, Stack, DialogProps, Select  } from "@mui/material";
import { Button } from '@mui/material';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { HDatums, VDatums, Units, Projections } from "constants/common";
import { useDispatch, useSelector} from 'react-redux';
import { closeVoxelPointCloudDialog} from 'store/main/viewObjects';
import { voxbmrotation, coordonateOrders } from "constants/common";
import { RootState } from 'store';
import { styled } from "@mui/material/styles";
import { getCachedData } from "api/Cache";
import { LocalizationProvider, MobileDateTimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import axios from 'axios';
import LinearProgress from '@mui/material/LinearProgress';
import AlertNotification from "components/AlertNotification";
import EventsEmitter from "events/EventsEmitter";
import { CircularProgress } from "@mui/material";
import { CircularProgressWithLabel } from "components";
import jwtService from 'services/jwtService';
import AuthService from "services/AuthService";
import { config } from "config";
import { updateData } from "services/CacheService";
import NotificationModel from 'components/notificationPanel/model/NotificationModel';
import { addNotification } from 'components/notificationPanel/store/dataSlice';
import NotificationMsg from "../NotificationMsg";

dayjs.extend(utc);
dayjs.extend(timezone);
const EST = "America/New_York";

function VoxelPointCloud(props:any) {
    const data = getCachedData();
    const {project, catalogId, file_type, isFolder} = props;
    const dispatch = useDispatch();
    const org = config.org;
    //const org = useSelector((state: RootState) => state.auth.data.org);
    const [files, setFiles] = useState<any>([]);
    const [itemName, setItemName] = useState('')
    const [itemNameError, setItemNameError] = useState(false)
    const [helperItemName, setHelperItemName] = useState('')
    const [captureDate, setCaptureDate] = useState<any>(null)
    const [horizontalDatum, setHorizontalDatum] = useState('')
    const [verticalDatum, setVerticalDatum] = useState('')
    const [projections, setProjections] = useState('')
    const [showForm, setShowForm] = useState(true)
    const [horizontalUnits, setHorizontalUnits] = useState('')
    const [verticalUnits, setVerticalUnits] = useState('')
    const [selectedFile, setSelectedFile] = useState(false);
  	const [message, setMessage] = useState('')
	const [alertType, setAlertType] = useState('')
	const [loading, setLoading] = useState(false)
	const [progress, setProgress] = useState(false)
  	const [uploadProgress, setUploadProgress] = useState<any>([]);
    const [remainingTime, setRemainingTime] = useState<any>([]);
    const [isUploading, setIsUploading] = useState(false);
    const [entity, setEntity] = useState<any>(null);
  
    const [orthovoxtranslateX, setorthovoxtranslateX] = useState<number>(0)
    const [orthovoxtranslateY, setorthovoxtranslateY] = useState<number>(0)
    const [orthovoxtranslateZ, setorthovoxtranslateZ] = useState<number>(0)
    const [orthovoxscaleX, setorthovoxscaleX] = useState(1)
    const [orthovoxscaleY, setorthovoxscaleY] = useState(1)
    const [orthovoxscaleZ, setorthovoxscaleZ] = useState(1)
    const [orthovoxRotateX, setOrthovoxRotateX] = useState<number>(0)
    const [orthovoxRotateY, setOrthovoxRotateY] = useState<number>(0)
    const [orthovoxRotateZ, setOrthovoxRotateZ] = useState<number>(0)
    const [orthovoxRotateOrder, setOrthovoxRotateOrder] = useState('ZXZ')
    const [coordonateOrder, setCoordonateOrder] = useState('XYZ')
    const [coordOriginX, setCoordOriginX] = useState('')
    const [coordOriginY, setCoordOriginY] = useState('')
    const [coordOriginZ, setCoordOriginZ] = useState('')
    const [voxelSize, setVoxelSize] = useState('')
   
    const [sizeb, setSize] = useState(0)
    const [progressLoading, setProgressLoading] = useState(0);
    const viewObject = useSelector((state: RootState) => state.main.viewObject);
    const { objName, vpcstate:open } = viewObject;
 
    const closeComposeDialog: DialogProps["onClose"] = (event, reason) => {
        if (reason && reason === "backdropClick")
            return;

        if(reason === "escapeKeyDown")
             cancel()
    }

	const cancel = () => {
		setFiles([])
		dispatch(closeVoxelPointCloudDialog({}))
		setProgress(false)
		setLoading(false)
        setShowForm(true)
	}
 
    const handleName = (e:any) => {
        setItemName(e.target.value)
        if(e.target.value === ''){
            setItemNameError(true);
            setHelperItemName("Please select a name");
        }else{
            setItemNameError(false);
            setHelperItemName("");
        }
    }

    useEffect(() => {
        if (!entity) return;
        if (progress) return;
        if (alertType !== 'success') return;
        //updateData("update", "entities", entity.project, entity, (id: string) => {});
        //dispatch(closeVoxelPointCloudDialog({}))
    })

    

    const CustomTextField = styled(TextField)({
        "& .MuiInputBase-root": {
          height: "40px", // Set your desired height
        },
    });

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            setLoading(false)
            setFiles([...event.target.files]);  
            setSelectedFile(true)
			setUploadProgress(new Array(event.target.files.length).fill(0));
            setRemainingTime(new Array(event.target.files.length).fill(''));
        }
    };

    const getEstimatedTime = (timeInSeconds: number) => {
        const hours = Math.floor(timeInSeconds / 3600);
        const minutes = Math.floor(timeInSeconds / 60 - hours * 60);
        const seconds = Math.floor(timeInSeconds - minutes * 60 - hours * 3600);

        let timeString = `${seconds} sec`;
        minutes && (timeString = `${minutes} min ${timeString}`);
        hours && (timeString = `${hours} hrs ${timeString}`);

        return timeString;
    }
    

    useEffect(() => {
      setShowForm(true)
    }, [])
    

    const DialogAction = () => {
        return (
            showForm ? 
            <>
                <Button onClick={cancel}>Cancel</Button>
                <Button 
                    variant="contained"
                    color="primary"
                    disabled={!selectedFile}
                    type="submit" onClick={handleUpload}
                >
                    { isUploading ? "Uploading" : "Create"}
                </Button>
            </>
            : ''
        )
    }

    
 	const uploadFilesRecursively = async (files:any, index = 0, id : any, sizeb = 0, uploadedSize = 0) => {

        const totalSize:any = Array.from(files).reduce((sum, file:any) => sum + file.size, 0);

      	// Base case: Stop recursion when all files are processed
		if (index >= files.length) {
            setShowForm(false)

            const requestData = {
                state: "COMPLETE",
                file_size: totalSize
            }
            try{
                const response = await jwtService.fetchRequest({
                    method: 'POST',
                    url: `/entity.ashx?id=${id}&project=${project}`,
                    data: requestData,
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    }
                });

                if(response.data.result === 'success') {
                    setAlertType('success')
                    setIsUploading(false);
                    setMessage('File uploading successfully completed')
                    setProgress(false);
                    setAlertType('success')
                    setIsUploading(false);
                    setMessage('File uploading successfully completed')
                    setProgress(false)
                } else {
                    setAlertType('error')
                    setMessage('An error occurs during the upload process');
                    setProgress(false)
                }
                EventsEmitter.emit("reloadData", "");

                
                 if(response.data.result === 'success') {

                    const id = response.data.id;
                    
                    const formData = new FormData();
                    formData.append("process", `IMPORT_${file_type}`);
        
                    const resp = await axios.post(`/events.ashx?project=${project}&id=${id}&org=${org}`, formData, {
                    headers: { 
                        'Content-Type': 'multipart/form-data',
                        'Authorization': `Bearer ${AuthService.getToken()}`,
                        },
                    });
        
                    if(resp.data.result === 'success'){
                        //dispatch(addNotification(NotificationModel({ message: <NotificationMsg msg={itemName}/>, options: { variant: 'success' } })));
                        //EventsEmitter.emit("reloadData", "");
                        setAlertType('success')
                        setIsUploading(false);
                        setMessage('File uploading successfully completed')
                        setProgress(false);
                        dispatch(closeVoxelPointCloudDialog({}))
                    }else{
                        setAlertType('error')
                        setMessage('An error occurs during the upload process');
                        setProgress(false)
                        //dispatch(addNotification(NotificationModel({ message: 'An error occurs during the process upload', options: { variant: 'error' } })));
                    }
                    //EventsEmitter.emit("reloadData", "");
                    return;
                    
                }else{
                   
                    setAlertType('error')
                    setMessage('An error occurs during the upload process');
                    setProgress(false)
                    return;
                    //dispatch(addNotification(NotificationModel({ message: 'An error occurs during the process upload', options: { variant: 'error' } })));
                }
                

            } catch(e) {
                console.error(e);
                setAlertType('error')
                setMessage('An error occurs during the upload process');
                setProgress(false)
                //dispatch(addNotification(NotificationModel({ message: 'An error occurs during the process upload', options: { variant: 'error' } })));
            }

            return;
		}
	
		const file = files[index];
		const formData = new FormData();
		formData.append("file", file);
	
		try {
			// Simulate file upload with fetch API
	        const url = config.api.baseUrl + "/" + config.api.endpoints["file"] + `?project=${project}&id=${id}&org=${org}&partialsize=${sizeb}`;

			const formData = new FormData();
			formData.append('file', file);
		                    
			const response = await axios.post(url, formData, {
				headers: { 
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${AuthService.getToken()}`,
                 },
                // onDownloadProgress : onUploadProgress
                onUploadProgress: (progressEvent) => {
                    if (progressEvent.total) {
                        const remainingTime = getEstimatedTime(progressEvent.estimated || 0);
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        uploadedSize += progressEvent.loaded;
                        //const overallProgress = Math.round((uploadedSize / totalSize) * 100);
                        //console.log(`Overall Progress : ${overallProgress}%`)
                        setMessage(`${file.name} Upload progress: ${percentCompleted}% ${remainingTime}`);

                        setUploadProgress((prevProgress:any) => {
                            const updatedProgress = [...prevProgress];
                            updatedProgress[index] = percentCompleted;
                            return updatedProgress; // Set progress to 100% for the current file
                        });
                        setRemainingTime((state:any) => {
                            const oldState = [...state];
                            oldState[index] = remainingTime;
                            return oldState;
                        });

                    } else {
                        console.log(`Uploaded ${progressEvent.loaded} bytes (total unknown)`);
                    }
                },
			});
				
			// Recursively upload the next file
			await uploadFilesRecursively(files, index + 1, id, response.data.size, uploadedSize);

		} catch (error) {
			console.error(error);
            setAlertType('error')
            setMessage('An error occurs during the upload process');
            setProgress(false)
		}
	};
    

    const uploadFiles = async (files:any) => {
        const totalSize:any = Array.from(files).reduce((sum, file:any) => sum + file.size, 0);

        const progressContainer = document.getElementById('progressContainer')
        if (!progressContainer) {
            console.error('Progress container element not found');
            return; // Stop execution if the container is missing
        }
        progressContainer.innerHTML = ''; // Clear previous progress info
		//setSize(0)
		setProgress(true)
		setLoading(true)
		setAlertType('warning')
		setMessage('Please keep this tab open until the upload process completes')

        let requestData = {
            name: itemName,
            capture_date: captureDate.valueOf().toString(),
            type: "FILE",
            state: "PARTIAL",
            file_type: file_type,
            file_size: "0",
            file_date: Date.now().toString(),
            file_folder: isFolder ? catalogId : "0",
            entity_coord_hunit: horizontalUnits,
            entity_coord_vunit: verticalUnits,
            entity_coord_hdatum: horizontalDatum,
            entity_coord_vdatum: verticalDatum,
            entity_coord_projection: projections,
            translate_x: orthovoxtranslateX.toString(),
            translate_y: orthovoxtranslateY.toString(),
            translate_z: orthovoxtranslateZ.toString(), 
            scale_x: orthovoxscaleX.toString(),
            scale_y: orthovoxscaleY.toString(),
            scale_z: orthovoxscaleZ.toString(),
            rotate_x: orthovoxRotateX.toString(),
            rotate_y: orthovoxRotateY.toString(),
            rotate_z: orthovoxRotateZ.toString(),
            rotation_order: orthovoxRotateOrder,
            column_order : coordonateOrder,
            coord_origin_x: coordOriginX.toString(),
            coord_origin_y: coordOriginY.toString(),
            coord_origin_z: coordOriginZ.toString(),
            coord_hdatum: horizontalDatum,
            coord_vdatum: verticalDatum,
            coord_projection: projections,
            coord_projection_tm_falseEasting: "0.0",
            coord_projection_tm_falseNorthing: "0.0",
            coord_projection_tm_latOriginDeg: "0.0",
            coord_projection_tm_longMeridianDeg: "0.0",
            coord_projection_tm_scaleFactor: "0.0",
            coord_projection_lcc_falseEasting: "0.0",
            coord_projection_lcc_falseNorthing: "0.0",
            coord_projection_lcc_latOfOriginDeg: "0.0",
            coord_projection_lcc_longOfOriginDeg: "0.0",
            coord_projection_lcc_firstStdParallelDeg: "0.0",
            coord_projection_lcc_secondStdParallelDeg: "0.0",
            coord_projection_aeac_falseEasting: "0.0",
            coord_projection_aeac_falseNorthing: "0.0",
            coord_projection_aeac_latOfOriginDeg: "0.0",
            coord_projection_aeac_longOfOriginDeg: "0.0",
            coord_projection_aeac_firstStdParallelDeg: "0.0",
            coord_projection_aeac_secondStdParallelDeg: "0.0",
            coord_projection_amg_zone: "48",
            coord_unit: horizontalUnits,
            voxel_size: voxelSize
        }
        
       
        try{
            const response = await jwtService.fetchRequest({
                method: 'POST',
                url: `/entity.ashx?project=${project}`,
                data: requestData,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            });
    
            if(response.data.result === 'success') {
                setIsUploading(true);
                await uploadFilesRecursively(files, 0, response.data.id, 0, 0);
                setEntity({
                    ...requestData,
                    ID: response.data.id,
                    catalogId
                });
            }
        }catch(error) {
            console.error(error);
            setAlertType('error')
            setMessage('An error occurs during the upload process');
            setProgress(false)
        }
    };

    const handleUpload = async () => {
        setShowForm(false)
        await uploadFiles(files)
    };

    useEffect(() => {     
       
        const handleProgress = (curProgress: number) => {
            setProgressLoading(curProgress);
        };

        EventsEmitter.on("projects_progress", handleProgress);
        return () => {
            EventsEmitter.removeEventListener("projects_progress", handleProgress);
        };

    }, [data]);

	useEffect(() => {

        const currentDate = dayjs.tz(new Date(), EST);
        const projects: any = data["projects"][project];
        setCaptureDate(currentDate)
        setItemName("New " + objName)
        setHorizontalDatum(projects['coord_hdatum'])
        setVerticalDatum(projects['coord_vdatum'])
        setProjections(projects['coord_projection'])
        setHorizontalUnits(projects['coord_unit'])
        setVerticalUnits(projects['coord_unit'])

        setCoordOriginX(projects['coord_origin_x'])
        setCoordOriginY(projects['coord_origin_y'])
        setCoordOriginZ(projects['coord_origin_z'])
        setVoxelSize(projects['voxel_size'])

    }, [objName, data, project, sizeb])
    
    if (!data.loaded) {
        return progressLoading === 0 ? <CircularProgress /> : <CircularProgressWithLabel value={progressLoading} />;
    }

    return (
		<>
            <CommonDialogBox
                classes={{
                    paper: 'm-24 rounded-8 white-bg'
                }}
                open={open}
                handleClose={closeComposeDialog}
                fullWidth
                maxWidth="sm"
                subtitle1={`Upload ${objName}`}
                titleh5=''
                dialogAction={<DialogAction />}
                displayScrollBar={true}
                maxHeight={600}
                helpLinkCode="project-objects-voxel-point-cloud"
            >
                <div id="progressContainer" style={{ display:'none' }}></div>
                {
                loading && (
                    <>
                    <AlertNotification variant={"standard"} type={alertType} message={message} />
                    {
                    progress && (
                        <Box sx={{ width: '100%' }}>
                            <LinearProgress />
                        </Box>
                        )
                    }
                    </>
                    )
                }
                {
                showForm ? 
               
                <Stack 
                    gap={1}
                >
                    <TextField
                        sx={{
                            "& .MuiInputBase-root": {
                            height: "40px", // Set your desired height
                            },
                        }}
                        required
                        margin="dense"
                        id="itemName"
                        name="itemName"
                        label="Item Name"
                        error={itemNameError}
                        helperText={helperItemName}
                        value={itemName}
                        type="txt"
                        fullWidth
                        color='primary'
                        variant="outlined"
                        onChange={(e) => handleName(e)}
                        style={{marginBottom: '10px'}}
                    /> 
                    
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en">
                        <MobileDateTimePicker
                            label="Capture Date"
                            format="MM/DD/YYYY hh:mm A"
                            value={captureDate}
                            ampm={true}
                            onChange={(newValue) => setCaptureDate(dayjs.tz(newValue, EST))}
                            //onChange={(newValue) => setCaptureDate(newValue)}
                            sx={{
                                "& .MuiInputBase-root": {
                                height: "40px", // Set your desired height
                                },
                            }}
                            slotProps={{ textField: { fullWidth: true } }}
                        />
                    </LocalizationProvider>
             

                    <CustomTextField
                        sx={{
                            "& .MuiInputBase-root": {
                            height: "40px", // Set your desired height
                            },
                        }}
                        required
                        margin="dense"
                        id="horizontaldatum"
                        name="horizontaldatum"
                        label="Horizontal datum"
                        type="txt"
                        select
                        fullWidth
                        value={horizontalDatum}
                        color='primary'
                        variant="outlined"
                        onChange={(e) => setHorizontalDatum(e.target.value)}
                    > 
                        {
                            HDatums.map(item => <MenuItem value={item.value} key={item.value}>{item.text}</MenuItem>)
                        }
                    </CustomTextField> 
                    <CustomTextField
                        required
                        margin="dense"
                        id="verticaldatum"
                        name="verticaldatum"
                        label="Vertical datum"
                        type="txt"
                        select
                        fullWidth
                        value={verticalDatum}
                        color='primary'
                        variant="outlined"
                        onChange={(e) => setVerticalDatum(e.target.value)}
                    >
                        {
                            VDatums.map(item => <MenuItem value={item.value} key={item.value}>{item.text}</MenuItem>)
                        }
                    </CustomTextField> 
                    <CustomTextField
                        required
                        margin="dense"
                        id="projection"
                        name="projection"
                        label="Projection"
                        type="txt"
                        select
                        fullWidth
                        value={projections}
                        color='primary'
                        variant="outlined"
                        onChange={(e) => setProjections(e.target.value)}
                    >
                        {
                            Projections.map(item => <MenuItem value={item.value} key={item.value}>{item.text}</MenuItem>)
                        }
                    </CustomTextField> 
                    <CustomTextField
                        required
                        margin="dense"
                        id="horizontalUnits"
                        name="horizontalUnits"
                        label="Horizontal Units"
                        type="txt"
                        select
                        fullWidth
                        value={horizontalUnits}
                        color='primary'
                        variant="outlined"
                        onChange={(e) => setHorizontalUnits(e.target.value)}
                    >
                        {
                            Units.map(item => <MenuItem value={item.value} key={item.value}>{item.text}</MenuItem>)
                        }
                    </CustomTextField> 
                    <CustomTextField
                        required
                        margin="dense"
                        id="verticalUnits"
                        name="verticalUnits"
                        label="Vertical Units"
                        type="txt"
                        select
                        fullWidth
                        value={verticalUnits}
                        color='primary'
                        variant="outlined"
                        onChange={(e) => setVerticalUnits(e.target.value)}
                    >
                        {
                            Units.map(item => <MenuItem value={item.value} key={item.value}>{item.text}</MenuItem>)
                        }
                    </CustomTextField>

                    <TextField
                        sx={{
                            "& .MuiInputBase-root": {
                            height: "35px", // Set your desired height
                            fontSize : '13px'
                            },
                        }}
                        required
                        margin="dense"
                        id="orthovox-translate-x"
                        name="orthovox-translate-x"
                        label="Translate X"
                        value={orthovoxtranslateX}
                        type="txt"
                        fullWidth
                        color='primary'
                        variant="outlined"
                        onChange={(e) => setorthovoxtranslateX(parseInt(e.target.value))}
                    /> 
                   <TextField
                        sx={{
                            "& .MuiInputBase-root": {
                            height: "35px", // Set your desired height
                            fontSize : '13px'
                            },
                        }}
                        required
                        margin="dense"
                        id="orthovox-translate-y"
                        name="orthovox-translate-y"
                        label="Translate Y"
                        value={orthovoxtranslateY}
                        type="txt"
                        fullWidth
                        color='primary'
                        variant="outlined"
                        onChange={(e) => setorthovoxtranslateY(parseInt(e.target.value))}
                    />
                    <TextField
                        sx={{
                            "& .MuiInputBase-root": {
                            height: "35px", // Set your desired height
                            fontSize : '13px'
                            },
                        }}
                        required
                        margin="dense"
                        id="orthovox-translate-z"
                        name="orthovox-translate-z"
                        label="Translate Z"
                        value={orthovoxtranslateZ}
                        type="txt"
                        fullWidth
                        color='primary'
                        variant="outlined"
                        onChange={(e) => setorthovoxtranslateZ(parseInt(e.target.value))}
                    />
                             
                    <TextField
                        sx={{
                            "& .MuiInputBase-root": {
                            height: "35px", // Set your desired height
                            fontSize : '13px'
                            },
                        }}
                        required
                        margin="dense"
                        id="orthovox-scale-x"
                        name="orthovox-scale-x"
                        label="Scale X"
                        type="txt"
                        fullWidth
                        value={orthovoxscaleX}
                        color='primary'
                        variant="outlined"
                        onChange={(e) => setorthovoxscaleX(parseInt(e.target.value))}
                    /> 
                       
                    <TextField
                        sx={{
                            "& .MuiInputBase-root": {
                            height: "35px", // Set your desired height
                            fontSize : '13px'
                            },
                        }}
                        required
                        margin="dense"
                        id="orthovox-scale-y"
                        name="orthovox-scale-y"
                        label="Scale Y"
                        type="txt"
                        fullWidth
                        value={orthovoxscaleY}
                        color='primary'
                        variant="outlined"
                        onChange={(e) => setorthovoxscaleY(parseInt(e.target.value))}
                    /> 
                    <TextField
                        sx={{
                            "& .MuiInputBase-root": {
                            height: "35px", // Set your desired height
                            fontSize : '13px'
                            },
                        }}
                        required
                        margin="dense"
                        id="orthovox-scale-z"
                        name="orthovox-scale-z"
                        label="Scale Z"
                        type="txt"
                        fullWidth
                        value={orthovoxscaleZ}
                        color='primary'
                        variant="outlined"
                        onChange={(e) => setorthovoxscaleZ(parseInt(e.target.value))}
                    /> 

                    <TextField
                        sx={{
                            "& .MuiInputBase-root": {
                            height: "35px", // Set your desired height
                            fontSize : '13px'
                            },
                        }}
                        required
                        margin="dense"
                        id="orthovox-rotate-x"
                        name="orthovox-rotate-x"
                        label="Rotate X"
                        type="txt"
                        fullWidth
                        value={orthovoxRotateX}
                        color='primary'
                        variant="outlined"
                        onChange={(e) => setOrthovoxRotateX(parseInt(e.target.value))}
                    /> 
                    <TextField
                        sx={{
                            "& .MuiInputBase-root": {
                            height: "35px", // Set your desired height
                            fontSize : '13px'
                            },
                        }}
                        required
                        margin="dense"
                        id="orthovox-rotate-y"
                        name="orthovox-rotate-y"
                        label="Rotate Y"
                        type="txt"
                        fullWidth
                        value={orthovoxRotateY}
                        color='primary'
                        variant="outlined"
                        onChange={(e) => setOrthovoxRotateY(parseInt(e.target.value))}
                    /> 
                    <TextField
                        sx={{
                            "& .MuiInputBase-root": {
                            height: "35px", // Set your desired height
                            fontSize : '13px'
                            },
                        }}
                        required
                        margin="dense"
                        id="orthovox-rotate-z"
                        name="orthovox-rotate-z"
                        label="Rotate Z"
                        type="txt"
                        fullWidth
                        value={orthovoxRotateZ}
                        color='primary'
                        variant="outlined"
                        onChange={(e) => setOrthovoxRotateZ(parseInt(e.target.value))}
                    /> 
      
                    <TextField
                        sx={{
                            "& .MuiInputBase-root": {
                            height: "35px", // Set your desired height
                            fontSize : '13px'
                            },
                        }}
                        required
                        margin="dense"
                        id="orthovox-select-rotation-order"
                        name="orthovox-select-rotation-order"
                        label="Rotate Order"
                        type="txt"
                        select
                        fullWidth
                        value={orthovoxRotateOrder}
                        color='primary'
                        variant="outlined"
                        onChange={(e) => setOrthovoxRotateOrder(e.target.value)}
                    >
                        {
                            voxbmrotation.map(item => <MenuItem value={item.value} key={item.value}>{item.text}</MenuItem>)
                        }
                    </TextField> 

                    <TextField
                        sx={{
                            "& .MuiInputBase-root": {
                            height: "35px", // Set your desired height
                            fontSize : '13px'
                            },
                        }}
                        required
                        margin="dense"
                        id="coordonate_order"
                        name="coordonate_order"
                        label="Coordonate Order"
                        type="txt"
                        select
                        fullWidth
                        value={coordonateOrder}
                        color='primary'
                        variant="outlined"
                        onChange={(e) => setCoordonateOrder(e.target.value)}
                    >
                        {
                           coordonateOrders.map(item => <MenuItem value={item.value} key={item.value}>{item.text}</MenuItem>)
                        }
                    </TextField>
                   
                    <Box display="flex" flexDirection="row" alignItems="center" justifyContent="space-between" gap={2} style={{marginTop: '5px'}}>
                       
                        <div>
                            { 
                            files.length > 0 && (
                                files.map((file:any, index:any) => (
                                    <Typography variant="body1" style={{ display:'flex', fontSize: '11px', padding:' 0 10px' }} key={index}> {file.name}<div style={{fontWeight:'600'}}></div></Typography>                                   
                                 ))
                            )}
                        </div>
                        <input
                            accept="*"
                            style={{ display: "none", marginBottom:'10px' }}
                            id="file-upload"
                            multiple={objName === 'Mesh' ? false : true}
                            type="file"
                            onChange={(e) => handleFileChange(e)}
                        />
                        <label htmlFor="file-upload">
                            <Button variant="contained" color="info" component="span">
                            Choose File
                            </Button>
                        </label>
                    </Box>
                </Stack>
                : ''
                }
            </CommonDialogBox>
		</>
  	)
}

export default VoxelPointCloud